import Configurations from '@/views/configurations'
import PageBase from '@/views/configurations/base'
import NotFound from '@/views/configurations/404'

import ConfigurationsUrlActions from '@/views/configurations/advanced/url-actions'

import CompanyGeneral from '@/views/configurations/company/general'
import CompanyLinksApps from '@/views/configurations/company/links-apps'
import Authentication from '@/views/configurations/company/authentication'

import FilesTypes from '@/views/configurations/files/types'
import FilesStoreLimits from '@/views/configurations/files/limits'

import UsersGeneral from '@/views/configurations/users/general'
import UsersGroups from '@/views/configurations/users/groups'
import UsersDynamics from '@/views/configurations/users/dynamics'

import CustomersGeneral from '@/views/configurations/customers/general'
import CustomersPermissions from '@/views/configurations/customers/permissions'
import CustomersSaleDate from '@/views/configurations/customers/sale-date'
import CustomersOrigens from '@/views/configurations/customers/origens'
import CustomersOrigins from '@/views/configurations/customers/origins'
import CustomersChannels from '@/views/configurations/customers/channels'
import CustomersDuplicity from '@/views/configurations/customers/duplicity'
import CustomersRequiredFields from '@/views/configurations/customers/required-fields'
import CustomersIdlenessRules from '@/views/configurations/customers/idleness-rules'

import ClubGeneral from '@/views/configurations/club/general'
import ClubPermissions from '@/views/configurations/club/permissions'

import SalesFunnelGeneral from '@/views/configurations/sales-funnel/general'
import SalesFunnelCallTracking from '@/views/configurations/sales-funnel/call-tracking'
import SalesFunnelStageStatus from '@/views/configurations/sales-funnel/stage-status'
import SalesFunnelActionsRules from '@/views/configurations/sales-funnel/actions-rules'
import SalesFunnelPermissions from '@/views/configurations/sales-funnel/permissions'

import ReservesPermissions from '@/views/configurations/reserves/permissions'
import ReservesDuplicity from '@/views/configurations/reserves/duplicity'
import ReservesRequiredFields from '@/views/configurations/reserves/required-fields'
import ReservesProfessionalManagement from '@/views/configurations/reserves/professional-management'

import ProposalDuplicity from '@/views/configurations/proposal/duplicity'
import ProposalRequiredFields from '@/views/configurations/proposal/required-fields'
import ProposalFields from '@/views/configurations/proposal/fields'
import ProposalSimulator from '@/views/configurations/proposal/proposal-simulator'
import ProposalFillProposal from '@/views/configurations/proposal/digital-folder'
import ProposalPaymentFields from '@/views/configurations/proposal/payment'
import ContractGroups from '@/views/configurations/proposal/contract-groups'
import ProposalSeries from '@/views/configurations/proposal/series'
import SalesTable from '@/views/configurations/proposal/sales-table'

import PermissionsBusiness from '@/views/configurations/business/permissions'
import GeneralBusiness from '@/views/configurations/business/general'

import integrationsAdvanced from '@/views/configurations/integrations/advanced'

import { storage } from '@/services/storage'

const defaultPermissions = () => ({
	groups: ['broker', 'manager', 'supervisor'],
	redirect: { name: 'errors.not.unauthorized' }
})

const routes = [
	{
		path: '/configuracoes',
		name: 'configurations',
		component: Configurations,
		redirect: 'configuracoes/empresa/dados-empresa',
		meta: {
			title: (storage.get('client_name') || 'Facilita') + ' - Configurações',
			protect: true,
			permissions: { ...defaultPermissions() },
		},
		children: [
			{
				path: 'avancado',
				name: 'configurations.advanced',
				component: PageBase,
				redirect: 'configuracoes',
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Configurações Avançadas',
					protect: true,
					permissions: {
						...defaultPermissions(),
						permissions: ['super_admin']
					},
				},
				children: [
					{
						path:'acoes/:id',
						name:'configurations.advanced.url_code',
						component: ConfigurationsUrlActions,
						props: true,
						meta: {
							title: (storage.get('client_name') || 'Facilita') + ' - Configurações Avançadas' + '- Ação',
							protect: true,
							permissions: {
								...defaultPermissions(),
								permissions: ['super_admin']
							},
							infos: {
								menu: 'avancado',
								title: 'Configurações Avançadas',
								subtitle: 'URL de Ação',
							},
						},
					},
					{
						path: 'modo-debuger',
						name: 'configurations.advanced.debug-mode',
						component: integrationsAdvanced,
						meta: {
							title: (storage.get('client_name') || 'Facilita') + ' - Configurações Avançadas' + '- Modo Debuger',
							protect: true,
							permissions: { 
								...defaultPermissions(),
								permissions: ['super_admin'] 
							},
							infos: {
								menu: 'avancado',
								title: 'Configurações Avançadas',
								subtitle: 'Depuração do Envio de Propostas',
							},
						},
					},
				]
			},
			{
				path: 'empresa',
				name: 'configurations.company',
				component: PageBase,
				redirect: 'empresa/dados-empresa',
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Empresa',
					protect: true,
					permissions: { ...defaultPermissions() },
				},
				children: [
					{
						path: 'dados-empresa',
						name: 'configurations.company.companydata',
						component: CompanyGeneral,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Empresa - Dados da Empresa',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'empresa',
								title: 'Empresa',
								subtitle: 'Dados da Empresa',
							},
						},
					},
					{
						path: 'links-apps',
						name: 'configurations.company.linksapp',
						component: CompanyLinksApps,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Empresa - Links dos Aplicativos',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'empresa',
								title: 'Empresa',
								subtitle: 'Links dos Aplicativos',
							},
						},
					},
					{
						path: 'autenticacao',
						name: 'configurations.company.authentication',
						component: Authentication,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Empresa - Autenticação',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'empresa',
								title: 'Empresa',
								subtitle: 'Autenticação',
							},
						},
					},
				],
			},
			{
				path: 'arquivos',
				name: 'configurations.files',
				component: PageBase,
				redirect: 'arquivos/tipos-de-arquivos',
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Arquivos',
					protect: true,
					permissions: { ...defaultPermissions() },
				},
				children: [
					{
						path: 'tipos-de-arquivos',
						name: 'configurations.files.filetypes',
						component: FilesTypes,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Arquivos - Tipos de Arquivos',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'arquivos',
								title: 'Arquivos',
								subtitle: 'Tipos de Arquivos',
							},
						},
					},
					{
						path: 'limites-de-armazenamento',
						name: 'configurations.files.store.limits',
						component: FilesStoreLimits,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Arquivos - Limites de Armarzenamento',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'arquivos',
								title: 'Arquivos',
								subtitle: 'Limites de Armarzenamento',
							},
						},
					},
				],
			},
			{
				path: 'usuarios',
				name: 'configurations.users',
				component: PageBase,
				redirect: 'usuarios/novos-cadastros',
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Usuários',
					protect: true,
					permissions: { ...defaultPermissions() },
				},
				children: [
					{
						path: 'novos-cadastros',
						name: 'configurations.users.newleads',
						component: UsersGeneral,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Usuários - Novos Cadastros',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'usuarios',
								title: 'Usuários',
								subtitle: 'Novos Cadastros',
							},
						},
					},
					{
						path: 'grupos',
						name: 'configurations.users.groups',
						component: UsersGroups,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Usuários - Grupos de Usuários',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'usuarios',
								title: 'Usuários',
								subtitle: 'Grupos de Usuários',
							},
						},
					},
					{
						path: 'perfis-dinamicos',
						name: 'configurations.users.dynamics',
						component: UsersDynamics,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Usuários - Perfis Dinâmicos',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'usuarios',
								title: 'Usuários',
								subtitle: 'Perfis Dinâmicos',
							},
						},
					},
				],
			},
			{
				path: 'clientes',
				name: 'configurations.customers',
				component: PageBase,
				redirect: 'clientes/geral',
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Clientes',
					protect: true,
					permissions: { ...defaultPermissions() },
				},
				children: [
					{
						path: 'geral',
						name: 'configurations.customers.general',
						component: CustomersGeneral,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Clientes - Configurações Gerais',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'clientes',
								title: 'Clientes',
								subtitle: 'Configurações Gerais',
							},
						},
					},
					{
						path: 'permissoes',
						name: 'configurations.customers.permissions',
						component: CustomersPermissions,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Clientes - Permissões',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'clientes',
								title: 'Clientes',
								subtitle: 'Permissões',
							},
						},
					},
					{
						path: 'data-venda',
						name: 'configurations.customers.saledate',
						component: CustomersSaleDate,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Clientes - Data de Venda',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'clientes',
								title: 'Clientes',
								subtitle: 'Data de Venda',
							},
						},
					},
					{
						path: 'origens-de-atendimento',
						name: 'configurations.customers.origens',
						component: CustomersOrigens,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Clientes - Origens de Atendimento',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'clientes',
								title: 'Clientes',
								subtitle: 'Origens de Atendimento',
							},
						},
					},
					{
						path: 'canais',
						name: 'configurations.customers.channels',
						component: CustomersChannels,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') + ' - Clientes - Canais',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'clientes',
								title: 'Clientes',
								subtitle: 'Canais',
							},
						},
					},
					{
						path: 'origens',
						name: 'configurations.customers.origins',
						component: CustomersOrigins,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Clientes - Origens',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'clientes',
								title: 'Clientes',
								subtitle: 'Origens',
							},
						},
					},
					{
						path: 'regras-de-ociosidade',
						name: 'configurations.customers.idleness',
						component: CustomersIdlenessRules,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Clientes - Regras de Ociosidade',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'clientes',
								title: 'Clientes',
								subtitle: 'Regras de Ociosidade',
							},
						},
					},
					{
						path: 'campos-obrigatorios',
						name: 'configurations.customers.required',
						component: CustomersRequiredFields,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Clientes - Campos Obrigatórios',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'clientes',
								title: 'Clientes',
								subtitle: 'Campos Obrigatórios',
							},
						},
					},
					{
						path: 'duplicidade',
						name: 'configurations.customers.duplicity',
						component: CustomersDuplicity,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Clientes - Duplicidade',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'clientes',
								title: 'Clientes',
								subtitle: 'Duplicidade',
							},
						},
					},
				],
			},
			{
				path: 'clube',
				name: 'configurations.club',
				component: PageBase,
				redirect: 'clube/geral',
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Clube de Pontos',
					protect: true,
					permissions: { ...defaultPermissions() },
				},
				children: [
					{
						path: 'geral',
						name: 'configurations.club.general',
						component: ClubGeneral,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Clube de Pontos - Configurações Gerais',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'clube',
								title: 'Clube de Pontos',
								subtitle: 'Configurações Gerais',
							},
						},
					},
					{
						path: 'permissoes',
						name: 'configurations.club.permissions',
						component: ClubPermissions,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Clube de Pontos - Permissões',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'clube',
								title: 'Clube de Pontos',
								subtitle: 'Permissões',
							},
						},
					},
				],
			},
			{
				path: 'funil-de-vendas',
				name: 'configurations.salesfunnel',
				component: PageBase,
				redirect: 'funil-de-vendas/geral',
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Funil de Vendas',
					protect: true,
					permissions: { ...defaultPermissions() },
				},
				children: [
					{
						path: 'geral',
						name: 'configurations.salesfunnel.general',
						component: SalesFunnelGeneral,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Funil de Vendas - Configurações Gerais',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'funil-de-vendas',
								title: 'Funil de Vendas',
								subtitle: 'Configurações Gerais',
							},
						},
					},
					{
						path: 'call-tracking',
						name: 'configurations.salesfunnel.calltracking',
						component: SalesFunnelCallTracking,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Funil de Vendas - Call Tracking',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'funil-de-vendas',
								title: 'Funil de Vendas',
								subtitle: 'Call Tracking',
							},
						},
					},
					{
						path: 'etapa-status',
						name: 'configurations.salesfunnel.stagestatus',
						component: SalesFunnelStageStatus,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Funil de Vendas - Etapa e Status',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'funil-de-vendas',
								title: 'Funil de Vendas',
								subtitle: 'Etapa e Status',
							},
						},
					},

					{
						path: 'acoes-do-funil',
						name: 'configurations.salesfunnel.actionsrules',
						component: SalesFunnelActionsRules,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Funil de Vendas - Ações do Funil',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'funil-de-vendas',
								title: 'Funil de Vendas',
								subtitle: 'Ações do Funil',
							},
						},
					},

					{
						path: 'ociosidade',
						name: 'configurations.salesfunnel.idleness',
						component: NotFound,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Funil de Vendas - Ociosidade',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'funil-de-vendas',
								title: 'Funil de Vendas',
								subtitle: 'Ociosidade',
							},
						},
					},
					{
						path: 'permissoes',
						name: 'configurations.salesfunnel.permissions',
						component: SalesFunnelPermissions,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Funil de Vendas - Permissões',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'funil-de-vendas',
								title: 'Funil de Vendas',
								subtitle: 'Permissões',
							},
						},
					}
				],
			},
			{
				path: 'reservas',
				name: 'configurations.reserves',
				component: PageBase,
				redirect: 'reservas/permissoes',
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Reservas',
					protect: true,
					permissions: { ...defaultPermissions() },
				},
				children: [
					{
						path: 'permissoes',
						name: 'configurations.reserves.permissions',
						component: ReservesPermissions,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Reservas - Permissões',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'reservas',
								title: 'Reservas',
								subtitle: 'Permissões',
							},
						},
					},
					{
						path: 'campos-obrigatorios',
						name: 'configurations.reserves.required',
						component: ReservesRequiredFields,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Reservas - Campos Obrigatórios',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'reservas',
								title: 'Reservas',
								subtitle: 'Campos Obrigatórios',
							},
						},
					},
					{
						path: 'duplicidade',
						name: 'configurations.reserves.duplicity',
						component: ReservesDuplicity,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Reservas - Duplicidade',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'reservas',
								title: 'Reservas',
								subtitle: 'Duplicidade',
							},
						},
					},
					{
						path: 'configuracoes-avancadas',
						name: 'configurations.reserves.professional.management',
						component: ReservesProfessionalManagement,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Reservas - Configurações Avanaçadas',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'reservas',
								title: 'Reservas',
								subtitle: 'Configurações Avançadas',
							},
						},
					},
				],
			},
			{
				path: 'propostas',
				name: 'configurations.proposal',
				component: PageBase,
				redirect: 'propostas/campos-obrigatorios',
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Propostas',
					protect: true,
					permissions: { ...defaultPermissions() },
				},
				children: [
					{
						path: 'campos-obrigatorios',
						name: 'configurations.proposal.required',
						component: ProposalRequiredFields,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Propostas - Campos Obrigatórios',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'propostas',
								title: 'Propostas',
								subtitle: 'Campos Obrigatórios',
							},
						},
					},
					{
						path: 'campos-proposta',
						name: 'configurations.proposal.fields',
						component: ProposalFields,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Propostas - Campos da Proposta',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'propostas',
								title: 'Propostas',
								subtitle: 'Campos da Proposta',
							},
						},
					},
					{
						path: 'duplicidade',
						name: 'configurations.proposal.duplicity',
						component: ProposalDuplicity,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Propostas - Duplicidade',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'propostas',
								title: 'Propostas',
								subtitle: 'Duplicidade',
							},
						},
					},
					{
						path: 'simulador-de-propostas',
						name: 'configurations.proposal.simulator',
						component: ProposalSimulator,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Propostas - Simulador de Propostas',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'propostas',
								title: 'Propostas',
								subtitle: 'Simulador de Propostas',
							},
						},
					},
					{
						path: 'preencher-proposta',
						name: 'configurations.proposal.fillproposal',
						component: ProposalFillProposal,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Propostas - Preencher Proposta',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'propostas',
								title: 'Propostas',
								subtitle: 'Preencher Proposta',
							},
						},
					},
					{
						path: 'campos-de-pagamento',
						name: 'configurations.proposal.paymentfields',
						component: ProposalPaymentFields,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Propostas - Campos de Pagamento',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'propostas',
								title: 'Propostas',
								subtitle: 'Campos de Pagamento',
							},
						},
					},
					{
						path: 'gerar-contratos',
						name: 'configurations.proposal.contractgroups',
						component: ContractGroups,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Propostas - Gerar Contratos',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'propostas',
								title: 'Propostas',
								subtitle: 'Gerar Contratos',
							},
						},
					},
					{
						path: 'series',
						name: 'configurations.proposal.series',
						component: ProposalSeries,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Propostas - Séries',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'propostas',
								title: 'Propostas',
								subtitle: 'Séries',
							},
						},
					},
					{
						path: 'tabela-de-vendas',
						name: 'configurations.proposal.salestable',
						component: SalesTable,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Propostas - Tabela de vendas',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'propostas',
								title: 'Propostas',
								subtitle: 'Tabela de Vendas',
							},
						},
					},				
				],
			},
			{
				path: 'negocios',
				name: 'configurations.business',
				component: PageBase,
				redirect: 'negocios/configuracoes-gerais',
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Negócios',
					protect: true,
					permissions: { ...defaultPermissions() },
				},
				children: [
					{
						path: 'configuracoes-gerais',
						name: 'configurations.business.general',
						component: GeneralBusiness,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Negócio - Configurações Gerais',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'negocios',
								title: 'Negócios',
								subtitle: 'Configurações Gerais',
							},
						},
					},
                    {
						path: 'permissoes',
						name: 'configurations.business.permissions',
						component: PermissionsBusiness,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') +
								' - Negócio - Permissões',
							protect: true,
							permissions: { ...defaultPermissions() },
							infos: {
								menu: 'negocios',
								title: 'Negócios',
								subtitle: 'Permissões',
							},
						},
					},
				],
			},
		],
	},
]

export { routes }
